<template>
  <div>
    <top-header :type="15" :placeholder="'装修首页'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem"
      @goBack="goback" />
    <img class="top_banner" src="@/assets/img/myFixtures.png" alt="">
    <div class="form_con">
      <van-form @submit="onSubmit">
        <!-- <van-field name="radio" label="房源类型">
          <template #input>
            <van-radio-group v-model="form.sfdk" direction="horizontal">
              <van-radio name="Y">新房</van-radio>
              <van-radio name="N">二手房</van-radio>
            </van-radio-group>
          </template>
        </van-field> -->
        <van-field v-model="form.name" name="姓名" label="姓名" placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="form.phone" type="number" name="手机号" label="手机号" placeholder="手机号"
          :rules="[{ validator: testPhone, message: '请填写正确的手机号' }]" />
        <van-field readonly clickable :value="company" label="装修公司" placeholder="请选择品牌合作家装公司"
          v-if="this.companyName && this.companyId" />
        <van-field readonly clickable name="picker" :value="company" label="装修公司" placeholder="请选择品牌合作家装公司"
          @click="showPicker = true" v-else :rules="[{ required: true, message: '请选择装修公司' }]" />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" value-key="name" @confirm="onConfirm"
            @cancel="showPicker = false" />
        </van-popup>
        <div style="padding:0.3rem;color:#ccc">
          选择“提交”，我们会为您提供及时的消息推送服务，并将收集您的姓名及手机号码用作后续的专属服务，届时将有专属客服人员与您电话联系，提供优质而专业的装修资讯服务。
        </div>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  name: 'fixtures',
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      showPicker: false,
      companyId: this.$route.query.companyId,
      companyName: this.$route.query.companyName,
      form: {
        phone: '',
        name: '',
        companyId: this.$route.query.companyId || "",
        remark: this.$route.query.name || "",
      },
      company: "",
      projectName: '',
      columns: [
      ]
    };
  },
  components: {
    topHeader
  },


  created() {
    if (this.companyId && this.companyName) {
      this.company = this.companyName
    } else {
      this.getOrgan()
    }
  },
  mounted() {

  },
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    testPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    getOrgan() {
      this.$request_again.post('decoration/company/all')
        .then(res => {
          if (res.success) {
            // this.company = res.result[0].name
            // this.form.companyId = res.result[0].id
            this.columns = res.result
          }
        });
    },
    onConfirm(n) {
      this.company = n.name;
      this.$set(this.form, 'companyId', n.id);
      this.showPicker = false;
    },
    onSubmit() {
      this.$dialog.confirm({
        confirmButtonColor: "#2F72F5",
        title: "提示",
        message: "我们会为您提供及时的消息推送服务，并将收集您的姓名及手机号码用作后续的专属服务，届时将有专属客服人员与您电话联系，提供优质而专业的装修资讯服务"
      })
        .then(() => {
          this.$request_again.post('decoration/report', qs.stringify(this.form)).then(res => {
            if (res.success) {
              this.$toast(res.message);
              setTimeout(() => {
                this.company = ''
                this.form.phone = ''
                this.form.remark = ''
                this.form.companyId = ''
                this.form.name = ''
                this.$router.replace('/home')
              }, 500)
            } else {
              this.$toast(res.message);
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    }
  },
};
</script>
<style lang="less" scoped>
.top_banner {
  width: 100%;
  height: 1.88rem;
  display: block;
}

.wrapper {
  position: fixed;
  top: 1.2rem;
  left: 0.23rem;
  right: 0.23rem;
  z-index: 5;

  .van-search {
    border-radius: 0.06rem 0.06rem 0 0;
  }

  .select_con {
    width: 100%;
    height: 50vh;
    background-color: #fff;
    padding: 0 12px;
    box-sizing: border-box;
    overflow: auto;

    p {
      font-size: 14px;
      padding: 10px 10px;
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
</style>